import Property1 from "../../assets/images/property/first/IMG_6101.webp";
import Property2 from "../../assets/images/property/second/IMG_6093.webp";
import Property3 from "../../assets/images/property/second/IMG_6096.webp";
import Property4 from "../../assets/images/property/4.webp";
import Property5 from "../../assets/images/property/5.webp";
import Property6 from "../../assets/images/property/6.webp";

import SubProperty1_1 from "../../assets/images/property/first/IMG_6101.webp";
import SubProperty1_2 from "../../assets/images/property/first/near.webp";
import SubProperty1_3 from "../../assets/images/property/first/road.webp";
import SubProperty1_4 from "../../assets/images/property/first/Backwoods.webp";

import SubProperty2_3 from "../../assets/images/property/second/lots.webp";
import SubProperty2_4 from "../../assets/images/property/second/lynx_lair.webp";
import SubProperty2_5 from "../../assets/images/property/second/new_2_drone.webp";

import SubProperty3_1 from "../../assets/images/property/third/IMG_6096.webp";
import SubProperty3_2 from "../../assets/images/property/third/IMG_6104.webp";
import SubProperty3_3 from "../../assets/images/property/third/Backwoods.webp";
import SubProperty3_4 from "../../assets/images/property/third/lynx_lair.webp";
import SubProperty3_5 from "../../assets/images/property/third/new_1_drone.webp";

import commonImage1 from "../../assets/images/property/common1.webp";
import commonImage2 from "../../assets/images/property/common2.webp";
import commonImage3 from "../../assets/images/property/common3.webp";
import commonImage4 from "../../assets/images/property/common4.webp";
import commonImage5 from "../../assets/images/property/common5.webp";
import commonImage6 from "../../assets/images/property/common6.webp";
import commonImage7 from "../../assets/images/property/common7.webp";
import commonImage8 from "../../assets/images/property/common8.webp";

import client1 from "../../assets/images/client/01.webp";
import client2 from "../../assets/images/client/02.webp";
import client3 from "../../assets/images/client/03.webp";
import client4 from "../../assets/images/client/04.webp";
import client5 from "../../assets/images/client/05.webp";
import client6 from "../../assets/images/client/06.webp";
import client7 from "../../assets/images/client/07.webp";
import client8 from "../../assets/images/client/08.webp";

import cate1 from "../../assets/images/property/residential.webp";
import cate2 from "../../assets/images/property/land.webp";
import cate3 from "../../assets/images/property/commercial.webp";
import cate4 from "../../assets/images/property/investment.webp";
import cate5 from "../../assets/images/property/industrial.webp";

import about1 from "../../assets/images/rent.webp";
import about2 from "../../assets/images/buy.webp";
import about3 from "../../assets/images/sell.webp";

import agency1 from "../../assets/images/agency/1.webp";
import agency2 from "../../assets/images/agency/2.webp";
import agency3 from "../../assets/images/agency/3.webp";
import agency4 from "../../assets/images/agency/4.webp";
import agency5 from "../../assets/images/agency/5.webp";
import agency6 from "../../assets/images/agency/6.webp";
import agency7 from "../../assets/images/agency/7.webp";
import agency8 from "../../assets/images/agency/8.webp";
import agency9 from "../../assets/images/agency/9.webp";

export const properties = [
  {
    id: 1,
    image: Property1,
    name: "Backwoods Trail, Evergreen, CO - 3 Build Sites",
    acres: 3,
    price: "Call to Ask",
    priority: 10,
    electric: true,
    water: true,
    internet: true,
    buildsites: 3,
    address: "Backwoods Trail, Evergreen, CO 80439",
    mapSrc:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1086.9983490138754!2d-105.34247784670444!3d39.59351656024361!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x876b7595d1cf4e21%3A0xb4613b62d3a86e8e!2sBackwoods%20Trl%2C%20Colorado%2080439%2C%20EE.%20UU.!5e0!3m2!1ses-419!2sdo!4v1758708110467!5m2!1ses-419!2sdo",
    description: `Tucked away on Backwoods Trail in Evergreen, Colorado, this +/- 3-acre property offers a rare blend of seclusion and convenience. Located along the "old road" before the area's newer developments, it provides a peaceful retreat while still being just moments from the main road and pavement all the way to the property's access road.

The property consists of six individual lots and surrounding easement lanes and parcels, thoughtfully grouped into three stunning build sites. Each site enjoys  western-facing rooftop and cascading deck and hot tub design opportunities, treating you to spectacular sunset views year-round. It's the kind of backdrop that turns everyday living into something extraordinary.

Practicality meets beauty here - the main road, just a few hundred feet away, already has water, electricity, natural gas, high-speed internet, and pavement in place. Whether you're looking to create a private mountain estate, develop multiple residences, or hold a unique investment property, this site offers an exceptional opportunity in one of Evergreen's most desirable settings.
`,
    detail: [
      SubProperty1_1,
      SubProperty1_2,
      SubProperty1_3,
      SubProperty1_4,
      commonImage1,
      commonImage2,
      commonImage3,
      commonImage4,
      commonImage5,
      commonImage6,
      commonImage7,
      commonImage8,
    ],
  },
  {
    id: 2,
    image: Property2,
    name: "Lynx Lair Rd, Evergreen, CO 80439 - 8 Build Sites",
    acres: 7.5,
    price: "Call to Ask",
    priority: 9,
    electric: true,
    water: true,
    internet: true,
    buildsites: 8,
    address: "Lynx Lair Rd, Evergreen, CO 80439",
    mapSrc:
      "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d196718.39717755426!2d-105.4617791!3d39.6108779!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x876b75be57f3d565%3A0x70adef65a95cb2df!2sLynx%20Lair%20Rd%2C%20Colorado%2080439%2C%20EE.%20UU.!5e0!3m2!1ses-419!2sdo!4v1758705122618!5m2!1ses-419!2sdo",
    description: `Unlock the potential of Evergreen's Panoramic Highlands with this rare opportunity to develop in one of the area's most sought-after mountain communities. These ~1-acre homesites offer west-facing views, engineered driveway plans, and direct paved access-ready for your next custom home project or small-scale build portfolio.

Each homesite offers tremendous development potential with engineered driveway plans already in place and paved road access right to the sites. Enjoy the ease of available utilities including electric, gas, and high-speed internet via junction boxes at each property. Water tap access is available (tap fee approx. $33K per lot, buyer to pay), and a septic system will be required.

With no metro district taxes and a voluntary HOA that maintains roads and mailboxes, this location provides flexibility and value for homeowners or builders alike.

Whether you're looking to build a luxury mountain home or create a portfolio of custom builds, Panoramic Highlands offers flexibility, utility access, and high buyer demand in a low-supply market.
Inquire today for survey, topo maps, and development packet. Let's talk about how this land can work for your next project.
`,
    detail: [
      Property2,
      SubProperty2_3,
      SubProperty2_4,
      SubProperty2_5,
      commonImage1,
      commonImage2,
      commonImage3,
      commonImage4,
      commonImage5,
      commonImage6,
      commonImage7,
      commonImage8,
    ],
  },
  {
    id: 3,
    image: Property3,
    name: "Lynx Lair Rd/Backwoods Trail, Evergreen, CO 80439 - Single Build Site",
    acres: 1,
    price: "Call to Ask",
    priority: 8,
    electric: true,
    water: true,
    internet: true,
    buildsites: 1,
    address: "Lynx Lair Rd/Backwoods Trail, Evergreen, CO 80439",
    mapSrc:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d116946.38120703865!2d-105.40810249611555!3d39.624535101763776!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x876b75be57f3d565%3A0x70adef65a95cb2df!2sLynx%20Lair%20Rd%2C%20Colorado%2080439%2C%20EE.%20UU.!5e0!3m2!1ses-419!2sdo!4v1758704985680!5m2!1ses-419!2sdo",
    description: `Discover your perfect mountain retreat site in the coveted Panoramic Highlands of Evergreen. This rare ±1-acre homesite offers sweeping west-facing views toward Mount Mt. Evans and unforgettable sunsets, all just minutes from Evergreen's schools, shops, dining, and services.

The property features a completed engineered driveway plan and direct paved road access, making the path from vision to build as seamless as possible. Utilities are conveniently located at the lot line-including electric, gas, and high-speed internet plus water tap access is available (tap fee approx. $33K, buyer to pay).

With no metro district taxes and a voluntary HOA that maintains roads and mailboxes without heavy restrictions, this site offers both flexibility and value.

Whether you dream of a custom luxury mountain home or a higher end family home, this location combines the beauty of the Rockies with year-round accessibility-perfect for your forever home or an investment build.

Property Highlights
•	±1-acre homesite in the heart of Evergreen's Panoramic Highlands
•	Engineered driveway plan completed for faster permitting
•	Paved road access-no off-road challenges
•	West-facing views and incredible Mount Blue Evans sunsets
•	Utilities at lot line: electric, gas, and high-speed internet
•	Water tap available (tap fee approx. $33K buyer responsibility)
•	Voluntary HOA with road/mailbox maintenance and minimal restrictions
•	No metro district taxes-lower long-term cost
•	Private mountain setting minutes from downtown Evergreen
`,
    detail: [
      SubProperty3_1,
      SubProperty3_2,
      SubProperty3_3,
      SubProperty3_4,
      SubProperty3_5,
      commonImage1,
      commonImage2,
      commonImage3,
      commonImage4,
      commonImage5,
      commonImage6,
      commonImage7,
      commonImage8,
    ],
  },
];

export const review = [
  {
    id: "1",
    profile: client1,
    name: "Calvin Carlo",
    designation: "Manager",
    description:
      "Hously made the processes so easy. Hously instantly increased the amount of interest and ultimately saved us over $10,000.",
  },
  {
    id: "2",
    profile: client2,
    name: "Christa Smith",
    designation: "Manager",
    description:
      'I highly recommend Hously as the new way to sell your home "by owner". My home sold in 24 hours for the asking price. Best $400 you could spend to sell your home.',
  },
  {
    id: "3",
    profile: client3,
    name: "Christa Smith",
    designation: "Manager",
    description:
      "My favorite part about selling my home myself was that we got to meet and get to know the people personally. This made it so much more enjoyable!",
  },
  {
    id: "4",
    profile: client4,
    name: "Christa Smith",
    designation: "Manager",
    description: "Great experience all around! Easy to use and efficient.",
  },
];
export const teamdata = [
  {
    image: client4,
    name: "Michael Chen",
    title: "Land Development Director",
  },
  {
    image: client5,
    name: "Sarah Rodriguez",
    title: "Engineering Manager",
  },
  {
    image: client6,
    name: "David Thompson",
    title: "Project Coordinator",
  },
  {
    image: client7,
    name: "Lisa Anderson",
    title: "Client Relations Manager",
  },
];

export const categoriesData = [
  {
    image: cate1,
    name: "Residential",
    title: "46 Listings",
  },
  {
    image: cate2,
    name: "Properties",
    title: "124 Listings",
  },
  {
    image: cate3,
    name: "Commercial",
    title: "265 Listings",
  },
  {
    image: cate4,
    name: "Industrial",
    title: "452 Listings",
  },
  {
    image: cate5,
    name: "Investment",
    title: "12 Listings",
  },
];

export const blogList = [
  {
    id: 1,
    title: "Skills That You Can Learn In The Real Estate Market",
    date: "13th March, 2023",
    type: "Industrial",
    image: Property1,
  },
  {
    id: 2,
    title: "Learn The Truth About Real Estate Industry",
    date: "5th May, 2023",
    type: "Industrial",
    image: Property2,
  },
  {
    id: 3,
    title: "10 Quick Tips About Business Development",
    date: "19th June, 2023",
    type: "Industrial",
    image: Property3,
  },
  {
    id: 4,
    title: "14 Common Misconceptions About Business Development",
    date: "20th June, 2023",
    type: "Industrial",
    image: Property4,
  },
  {
    id: 5,
    title: "10 Things Your Competitors Can Teach You About Real Estate",
    date: "31st Aug, 2023",
    type: "Industrial",
    image: Property5,
  },
  {
    id: 6,
    title: "Why We Love Real Estate",
    date: "1st Sep, 2023",
    type: "Industrial",
    image: Property6,
  },
];

export const aboutData = [
  {
    image: about1,
    title: "Rent a House",
    desc: "If the distribution of letters and 'words' is random, the reader will not be distracted from making.",
  },
  {
    image: about2,
    title: "Buy a House",
    desc: "If the distribution of letters and 'words' is random, the reader will not be distracted from making.",
  },
  {
    image: about3,
    title: "Sell a House",
    desc: "If the distribution of letters and 'words' is random, the reader will not be distracted from making.",
  },
];

export const agentData = [
  {
    id: 1,
    image: client4,
    name: "Jack John",
    position: "Property Broker",
  },
  {
    id: 2,
    image: client5,
    name: "Krista John",
    position: "Property Broker",
  },
  {
    id: 3,
    image: client6,
    name: "Roger Jackson",
    position: "Property Broker",
  },
  {
    id: 4,
    image: client7,
    name: "Johnny English",
    position: "Property Broker",
  },
  {
    id: 5,
    image: client8,
    name: "Clayton Dalke",
    position: "Property Broker",
  },
  {
    id: 6,
    image: client1,
    name: "Christopher Myers",
    position: "Property Broker",
  },
  {
    id: 7,
    image: client2,
    name: "Mary Petersen",
    position: "Property Broker",
  },
  {
    id: 8,
    image: client3,
    name: "Amber Durden",
    position: "Property Broker",
  },
];

export const agencyData = [
  {
    id: 1,
    image: agency1,
    name: "Realty Zen",
    title: "Real Estate Agency",
  },
  {
    id: 2,
    image: agency2,
    name: "Realty Zen",
    title: "Real Estate Agency",
  },
  {
    id: 3,
    image: agency3,
    name: "Realty Zen",
    title: "Real Estate Agency",
  },
  {
    id: 4,
    image: agency4,
    name: "Realty Zen",
    title: "Real Estate Agency",
  },
  {
    id: 5,
    image: agency5,
    name: "Realty Zen",
    title: "Real Estate Agency",
  },
  {
    id: 6,
    image: agency6,
    name: "Realty Zen",
    title: "Real Estate Agency",
  },
  {
    id: 7,
    image: agency7,
    name: "Realty Zen",
    title: "Real Estate Agency",
  },
  {
    id: 8,
    image: agency8,
    name: "Realty Zen",
    title: "Real Estate Agency",
  },
  {
    id: 9,
    image: agency9,
    name: "Realty Zen",
    title: "Real Estate Agency",
  },
];
